import { ScriptDef, ScriptTheme } from '../../types';

export const TV_XUANYI_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_074',
        name: '追尾灯',
        genre: 'tv',
        synopsis: '城东快速路一个月出了三起离奇追尾：被追的车都没事，追尾的司机一死两失踪，交警按事故结了案，刑侦二队却在第一辆车的行车记录仪里听出了别的动静。队长敬守一带着预审穆蓝、老刑侦毕振海、新警云凡重新立案。此后半年，二队的案子一个接一个，从套牌出租查到拆迁伤人，桩桩都是硬骨头。他们追着案子的尾灯跑，也一路撞见案子背后那些走投无路的普通人。',
        roles: [
            {
                name: '穆蓝',
                roleType: '女主角',
                billing: 1,
                intro: '二队预审，法医出身转刑侦。心细如发，卷宗翻得比谁都透，最恨「差不多得了」这句话。队里的疑难卷宗多半是她啃下来的。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '云凡',
                roleType: '男配角',
                billing: 3,
                intro: '刚分来的新警，警校一等奖学金，头一回下城中村办案就迷了路。他管毕振海叫师父，一口一个「海爷」，被骂急了也只会涨红脸。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '文雯',
                roleType: '女配角',
                billing: 5,
                intro: '二队户籍协警，辖区人口台账倒背如流，办案时是全队的活索引。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.Mystery, ScriptTheme.SeriousDrama],
        heat: 60,
        baseScore: 8.0,
    },
    {
        id: 'SCRIPT_075',
        name: '收网',
        genre: 'tv',
        synopsis: '2009年冬，云江边陆续浮起三具尸体，命案指向夜总会老板、绰号「老四」的本地人物。港区分局局长冷建国亲自挂帅，他知道这个案子背后网着一整个地下钱庄，也知道老四只是露在外面的一个角，江对岸替他递消息的人还没浮出水面。一场横跨两年的收网就此展开——警方在明处一点点收绳，老四在暗处一层层加码，两拨人隔着一条江，各自等着对方的破绽。',
        roles: [
            {
                name: '饶雨',
                roleType: '女配角',
                billing: 3,
                intro: '老四场子里的账房，管他的账，不管他的命。老四倒了以后，她是唯一一个还能把这两年资金往来对清楚的人。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '柴劲',
                roleType: '男配角',
                billing: 4,
                intro: '禁毒支队调来的年轻民警，混进老四的场子做眼线，在场子里当了两年泊车小弟。收网前一个月，他的身份差点被老四的人识破。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'stamina', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { talent: 3, stamina: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.Mystery, ScriptTheme.SeriousDrama],
        heat: 60,
        baseScore: 8.1,
    },
    {
        id: 'SCRIPT_076',
        name: '护城河底',
        genre: 'tv',
        synopsis: '河道清淤，一具沉了九年的尸体从护城河底被打捞上岸。法医程息认出死者是九年前定性为畏罪自杀的政协秘书沈怀。打捞队收队时，一封信被人塞进程息车里，落款是一支早已解散的厂子弟校合唱队。为了弄清这封信的由来，程息顺着当年合唱队七个孩子的下落一家一家找过去，找到了九个不肯开口的人。',
        roles: [
            {
                name: '程息',
                roleType: '女主角',
                billing: 1,
                intro: '市局法医，从业十六年，经手尸检三千余具。她每晚下班前都要把操作台再擦一遍，钥匙上挂着一枚从旧档案里捡的校徽。九年前，她就是在这条护城河边，亲手为那个被定性为"自杀"的沈怀，签下了尸检报告。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '沈怀',
                roleType: '男配角',
                billing: 2,
                intro: '当年的政协秘书，厂区里人人都认得他，会写毛笔字、会修收音机，是合唱队的队长兼指挥。他出事那天，兜里还揣着一张下周去省城参加合唱比赛的火车票。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '周循',
                roleType: '女配角',
                billing: 3,
                intro: '当年的刑警队长，如今在交警队执勤。她看着一摞尘封的旧卷宗，想起那个被所有人认定是自杀的下午。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Crime, ScriptTheme.SeriousDrama],
        heat: 67,
        baseScore: 9.0,
    },
    {
        id: 'SCRIPT_077',
        name: '销户',
        genre: 'tv',
        synopsis: '城中村拆迁，工人在地基里挖出一只铁皮饼干盒，盒里是一张盖了红章的劳动关系证明和一把断了齿的木梳。这张证明的主人，是二十八年前在一个雨夜失踪的纺织女工林月桂。刑警顾向北接手核查，发现系统里查不到她的任何身份记录——户口被注销、档案被归档、厂保卫科的说法是「外出打工没回来」。为了一张证、一把梳子，他沿着那条铁路线一站一站往回找，找到了一个又一个被注销的户口，却没有一个是她。',
        roles: [
            {
                name: '林月桂',
                roleType: '女配角',
                billing: 2,
                intro: '纺织厂女工，二十八年前那个雨夜之后再没有过户口。厂里的姐妹记得她手很巧，能用厂里用剩的线头给女儿打一件小衣服。那件小衣服，她只织了一半。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, talent: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Crime, ScriptTheme.SeriousDrama],
        heat: 65,
        baseScore: 8.7,
    },
    {
        id: 'SCRIPT_078',
        name: '失语名单',
        genre: 'tv',
        synopsis: '市档案馆门卫赵长顺快退休了，交接清点时，他对着库房深处一口落灰的木箱愣住——那里面是四十年前一桩命案的卷宗，封皮上被人用红笔写了个「免」字。他这辈子打过很多份工，卖过豆腐、开过拖拉机、守过火葬场，却从没对任何人提起，自己就是当年那起案子里的目击证人。四十年来，他守着这份名单，一个名字一个名字地咽下去，直到看见门外走进来一个跟他年轻时一样沉默的年轻人。',
        roles: [
            {
                name: '苏澈',
                roleType: '男二号',
                billing: 2,
                intro: '档案馆新来的整理员。他是冲着那份四十年前被封存的卷宗来的，却在翻开它之前，先学会了每天陪那个老头一起值班。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '小陆',
                roleType: '女配角',
                billing: 5,
                intro: '档案馆新入职的临时工，负责搬运和整理。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Crime, ScriptTheme.SeriousDrama],
        heat: 63,
        baseScore: 8.5,
    },
    {
        id: 'SCRIPT_079',
        name: '耳听为实',
        genre: 'tv',
        synopsis: '渝州老城区一口枯井被封了三十年后重新开启，井下竟埋着一具保存完好的女尸，面无腐坏、唇红齿白。富家千金沈知忆离奇失踪十五年，传闻她早被烧死。刑警顾诚束手无策，直至一位自称能「听声辨尸」、隔空算凶的盲人木先生凭空出场，指认凶手竟是沈知忆的初恋男友。全城哗然之际，几起尘封旧案的卷宗被神秘人逐页调换，线索全部指向十五年前那场「烧死」背后不可告人的真相。',
        roles: [
            {
                name: '顾诚',
                roleType: '男二号',
                billing: 2,
                intro: '刑警队副队长，办案雷厉风行，唯独拿木先生没办法。他始终不信巫术，却又不得不靠木先生指认凶手来结案。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '沈知忆',
                roleType: '女配角',
                billing: 3,
                intro: '沈家千金，失踪后被宣告死亡。十五年来，没有人相信她还活着——直到那具女尸出现。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Crime],
        heat: 34,
        baseScore: 4.2,
    },
    {
        id: 'SCRIPT_080',
        name: '暗账',
        genre: 'tv',
        synopsis: '1948年秋，北平。绥靖公署军需处的军需官韩缄管着华北十几万人的冬装与药材调拨，经他签字出库的每一笔账，都有另一本没有签字的账。剿总审计室奉命开进北平清查物资流向，带队的核查员阮青蘅调出的第一份卷宗，就是韩缄经手的那批"沉船损毁"的药品。一查一护之间，两人隔着一张办公桌过了四个月，直到腊月里最后一趟南下的军列发车。',
        roles: [
            {
                name: '韩缄',
                roleType: '男主角',
                billing: 1,
                intro: '军需处上校军需官，算盘打得比会计快，三年里两次错过升迁也不申辩。经手的账目极少出错，出错的那几笔，也从来查不到他头上。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '阮青蘅',
                roleType: '女主角',
                billing: 1,
                intro: '剿总审计室核查员，查出过两起大案，也逼死过一个无辜的军需科长。她查账有个习惯，先抄目录再翻页，从不跳着看。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '佟克明',
                roleType: '男二号',
                billing: 2,
                intro: '审计室副主任，韩缄黄埔时期的同期，入学成绩差他半分。他随身带一把算尺，核账先核自己经手的那几笔，是全审计室唯一不怕被反问的人。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '帮厨丫头',
                roleType: '女配角',
                billing: 5,
                intro: '军需处食堂的帮厨丫头，每天洗菜切葱揉面，一问三不知。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Spy, ScriptTheme.Period, ScriptTheme.SeriousDrama],
        heat: 54,
        baseScore: 8.9,
    },
    {
        id: 'SCRIPT_081',
        name: '晨钟',
        genre: 'tv',
        synopsis: '上海沦陷时期，荣家四代人经营的《晨钟报》还在每天清晨上街，只是头版要送新闻检查所预审。二少爷荣孟绥就在新闻检查所当检查官，删稿、撤稿、改标题，经他手放行的报纸有另一个版本的铅版。小少爷荣嘉树在苏州读中学，油印社里印着和《晨钟报》头版同一件事的不同写法。大姐荣怀璧两头的饭局都应酬，排字房的老师傅领了双份工钱，只知道每天深夜要对两次版。',
        roles: [
            {
                name: '荣孟绥',
                roleType: '男主角',
                billing: 1,
                intro: '二少爷，新闻检查所检查官，删过兄弟印的东西，也放行过删剩下的真相。他的红笔有个规矩，能整句删的不逐字删，稿子经他手过一遍，总还留着能拼回去的余地。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '荣嘉树',
                roleType: '男二号',
                billing: 2,
                intro: '小少爷，苏州中学学生，油印社的刻字员。他仿姐姐的笔迹仿了三年，苏州与报馆之间往来的稿件，多半经他的手转一道。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, wisdom: 3, charm: 2 },
            },
            {
                name: '桑静漪',
                roleType: '女二号',
                billing: 2,
                intro: '新闻检查所副所长，荣孟绥的上司，管着全所送审稿件的最后签发。她做事只认版面对不对得上，从《晨钟报》的一次头版铅版对位出了差错起，就盯上了这家报馆。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '郭翠喜',
                roleType: '女配角',
                billing: 4,
                intro: '排字房的学徒，认字不全，认铅字全——师傅说她的手比老排工还稳。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Spy, ScriptTheme.Period, ScriptTheme.SeriousDrama],
        heat: 50,
        baseScore: 8.3,
    },
    {
        id: 'SCRIPT_082',
        name: '显影',
        genre: 'tv',
        synopsis: '1940年，北平。宪兵队照相科的雇员越千帆，白天负责冲洗全城的侦查存档照片，晚上睡在药水味的暗房里。他按流程洗出的每一张照片都有编号，编号之外的东西他从来不多看一眼，直到一张照片里出现了他常去买颜料的铺子。裱画铺学徒荀湘的师父被带走后，铺子照常开门裱画，越千帆却把那张照片留在了身边。',
        roles: [
            {
                name: '越千帆',
                roleType: '男主角',
                billing: 1,
                intro: '照相科学徒，手稳，定影的火候拿捏得比师父准。他进宪兵队是为了口饭吃，从不问照片上拍的是谁，全城侦查存档的冲洗都从他手里过。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '荀湘',
                roleType: '女主角',
                billing: 1,
                intro: '裱画铺学徒，师父被带走后独自撑铺面，裱工没有一件出错。她揭裱旧画时手法极稳，再破的字纸到她手里都能拼回原样。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '冈部信',
                roleType: '男二号',
                billing: 2,
                intro: '宪兵队军曹，照片编号制度的制定者，验收存档从不假手他人。他记得照相科每卷底片该冲几次，多一次就要问到底。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, talent: 3, wisdom: 2 },
            },
            {
                name: '小翠',
                roleType: '女配角',
                billing: 5,
                intro: '照相科的杂役，在暗房外头跑腿，送药水、递底片盒，一天来回十几趟。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'stamina', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Spy, ScriptTheme.Period, ScriptTheme.Mystery],
        heat: 52,
        baseScore: 7.7,
    },
    {
        id: 'SCRIPT_083',
        name: '迷雾申江',
        genre: 'tv',
        synopsis: '1946年，上海。军统沪区行动队副队长秦铮身手过人，单枪匹马闯入敌方酒会夺回密件，事后在站务会上提出"情报工作靠的是胆识而非证据"的行动方针，获站长采纳。新入职的电讯员米澜上班第一天误拆一封绝密电报，反而因祸得福立功转正。此后历次行动，秦铮均能在合围前凭直觉脱身，并顺势端掉对方据点。中统暗斗、密电破译、米澜身世三条线索交替推进，最终于同日收拢，秦铮在北站当众公布身份，在场各方按约定放下武器。',
        roles: [
            {
                name: '秦铮',
                roleType: '男主角',
                billing: 1,
                intro: '行动队副队长，枪法、驾驶、破译样样精通，入站三年破大案十一件，最擅长在行动前夜凭感觉判断敌人动向，从无失手。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, stamina: 2, temperament: 2 },
            },
            {
                name: '米澜',
                roleType: '女主角',
                billing: 1,
                intro: '电讯员，入职一周便独立破译日方遗留密本，速度是全站平均值的三倍。业余爱好是替站里的枪支做保养，还给每支枪都起了名字。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '苏曼',
                roleType: '女二号',
                billing: 2,
                intro: '军统站里的机要秘书，跳舞全上海排得上号。她对秦铮一见倾心，每次行动都主动请缨留守电台等他报平安。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Spy, ScriptTheme.Action],
        heat: 38,
        baseScore: 5.7,
    },
];
